module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/toko"
    }
  }, [_vm._v("Toko")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/penjualan"
    }
  }, [_vm._v("Penjualan")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("PENJUALAN")]), _vm._v(" "), (this.data) ? _c('b', [_vm._v(_vm._s(this.nama_toko))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (this.data) ? _c('i', [_vm._v("periode " + _vm._s(this.tanggal1) + " s/d " + _vm._s(this.tanggal2))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "5px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "icon": "el-icon-search",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.filterDataPenjualan()
      }
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "type": "primary",
      "icon": "{this.hitLapHarianIsActive === false ? el-icon-document : el-icon-loading}",
      "size": "medium",
      "circle": "",
      "disabled": this.summary_menu_excel.length < 1 || this.laporan_harian2.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.getDataRawPenjualan()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-xl-6"
  }, [_c('div', {
    staticClass: "box palette-Grey-200 bg"
  }, [_c('div', {
    staticClass: "box-body no-pad padding-fifthin",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad padding-fifthin"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 bor-right bor-bottom"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [(_vm.data.sales) ? _c('div', {
    staticClass: "palette-Pink-500 text value"
  }, [_vm._v(_vm._s(_vm.data.sales.split(/ (.+)/)[1].replace(/\D/g, "")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Days")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 bor-bottom"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [(_vm.data.sales) ? _c('div', {
    staticClass: "palette-Purple-500 text value"
  }, [_vm._v(_vm._s(Math.round(parseFloat(_vm.data.avgNotDays) / parseFloat(_vm.data.sales.split(/ (.+)/)[1].replace(/\D/g, "")))))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Store")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 bor-right"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('div', {
    staticClass: "value palette-Deep-Purple-500 text"
  }, [_vm._v(_vm._s(_vm.data.not))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("NoT")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [(_vm.data.sales) ? _c('div', {
    staticClass: "value palette-Light-Blue-500 text"
  }, [_c('strong', [_vm._v("Rp ")]), _vm._v(_vm._s(parseFloat(parseFloat(parseFloat(_vm.data.sales.split(/ (.+)/)[0].replace(/\D/g, "")) / 1000).toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))), _c('strong', [_vm._v("K")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Sales Total")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xl-6"
  }, [_c('div', {
    staticClass: "box palette-Grey-200 bg"
  }, [_c('div', {
    staticClass: "box-body no-pad padding-fifthin",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad padding-fifthin"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 bor-right bor-bottom"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('div', {
    staticClass: "palette-Pink-500 text value"
  }, [_vm._v(_vm._s(_vm.data.avgNotDays))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Avg NoT/Days")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 bor-bottom"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('div', {
    staticClass: "palette-Purple-500 text value"
  }, [_vm._v(_vm._s(_vm.data.avgNotStore))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Avg Sales/Days")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 bor-right"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [(_vm.data.avgSalesTransaction) ? _c('div', {
    staticClass: "value palette-Deep-Purple-500 text"
  }, [_vm._v(_vm._s(parseFloat(parseFloat(parseFloat(_vm.data.avgSalesTransaction.replace(/,/g, '')) / 1000).toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))), _c('strong', [_vm._v("K")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Avg Sales/Transaction")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [(_vm.data.avgSalesDays) ? _c('div', {
    staticClass: "value palette-Light-Blue-500 text"
  }, [_c('strong', [_vm._v("Rp ")]), _vm._v(_vm._s(parseFloat(parseFloat(parseFloat(_vm.data.avgSalesDays.replace(/,/g, '')) / 1000).toFixed(1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))), _c('strong', [_vm._v("K")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Avg NoT/Store/Days")])])])])])])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Number of Transaction (NoT)")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.not))])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Sales Total")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.sales))])]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Average NoT / Day")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.avgNotDays))])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Average Sales / Day")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.avgSalesDays))])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Average Sales / Transaction")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.avgSalesTransaction))])]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Average NoT / Store / Day")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.avgNotStore))])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-500 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Grey-500 bg"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   Average Sales / Store / Day")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.avgSalesStore))])]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-200 bg"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('ve-line', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.chartSettings
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Grey-200 bg"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('ve-histogram', {
    attrs: {
      "data": _vm.barData,
      "settings": _vm.barSettings
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Berdasarkan Menu",
      "name": "menu"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%",
      "padding-right": "1px"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.summary_menu,
      "max-height": "410",
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(scope.row.no) + ".\n                              ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "MENU MASTER",
      "prop": "menu_master",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Menu Master"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariMenuMaster()
            }
          },
          model: {
            value: (_vm.cari_menu_master),
            callback: function($$v) {
              _vm.cari_menu_master = $$v
            },
            expression: "cari_menu_master"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.menu_master))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "MENU TOKO",
      "prop": "cari_menu_toko",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Menu Toko"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariMenuToko()
            }
          },
          model: {
            value: (_vm.cari_menu_toko),
            callback: function($$v) {
              _vm.cari_menu_toko = $$v
            },
            expression: "cari_menu_toko"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.menu_toko))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "QTY",
      "prop": "qty",
      "header-align": "center",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(_vm.toMoney(scope.row.qty)) + "\n                              ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RP",
      "prop": "value",
      "header-align": "center",
      "align": "center",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(_vm.toMoney(scope.row.value)) + "\n                              ")] : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Berdasarkan Stok Qty",
      "name": "barang"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%",
      "padding-right": "1px"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.laporan_harian,
      "max-height": "410",
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(scope.row.no) + ".\n                              ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "BARANG",
      "prop": "nama",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Menu Master"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariBarang()
            }
          },
          model: {
            value: (_vm.cari_barang),
            callback: function($$v) {
              _vm.cari_barang = $$v
            },
            expression: "cari_barang"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "PAKET",
      "prop": "paket",
      "header-align": "center",
      "align": "center",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(_vm.toMoney(scope.row.paket)) + "\n                              ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "NON PAKET",
      "prop": "nonpaket",
      "header-align": "center",
      "align": "center",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(_vm.toMoney(scope.row.nonpaket)) + "\n                              ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "WASTE",
      "prop": "ttlwaste",
      "header-align": "center",
      "align": "center",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(_vm.toMoney(scope.row.ttlwaste)) + "\n                              ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "TOTAL",
      "prop": "total",
      "header-align": "center",
      "align": "center",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                                " + _vm._s(_vm.toMoney(scope.row.total)) + "\n                              ")] : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalFilter),
      expression: "loadingModalFilter"
    }],
    attrs: {
      "title": "Filter Data Penjualan",
      "visible": _vm.dialogFormFilter,
      "close-on-click-modal": false,
      "width": "99%",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormFilter = $event
      }
    }
  }, [_c('el-form', {
    ref: "formFilter",
    staticClass: "demo-ruleForm",
    attrs: {
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(this.region.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Region",
      "prop": "region"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Region"
    },
    on: {
      "change": _vm.cbPilihRegion
    },
    model: {
      value: (_vm.regionSelected),
      callback: function($$v) {
        _vm.regionSelected = $$v
      },
      expression: "regionSelected"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.wilayah.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Wilayah",
      "prop": "wilayah"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Wilayah"
    },
    on: {
      "change": _vm.cbPilihWilayah
    },
    model: {
      value: (_vm.wilayahSelected),
      callback: function($$v) {
        _vm.wilayahSelected = $$v
      },
      expression: "wilayahSelected"
    }
  }, _vm._l((_vm.wilayah), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.area.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Area",
      "prop": "area"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Area"
    },
    on: {
      "change": _vm.cbPilihArea
    },
    model: {
      value: (_vm.areaSelected),
      callback: function($$v) {
        _vm.areaSelected = $$v
      },
      expression: "areaSelected"
    }
  }, _vm._l((_vm.area), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.cabang.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Cabang",
      "prop": "cabang"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Cabang"
    },
    on: {
      "change": _vm.cbPilihCabang
    },
    model: {
      value: (_vm.cabangSelected),
      callback: function($$v) {
        _vm.cabangSelected = $$v
      },
      expression: "cabangSelected"
    }
  }, _vm._l((_vm.cabang), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.toko.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Toko",
      "prop": "toko"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Toko"
    },
    on: {
      "change": _vm.cbPilihToko
    },
    model: {
      value: (_vm.tokoSelected),
      callback: function($$v) {
        _vm.tokoSelected = $$v
      },
      expression: "tokoSelected"
    }
  }, _vm._l((_vm.toko), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal Awal",
      "prop": "tanggal1"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "align": "left",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal Akhir",
      "prop": "tanggal2"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "align": "left",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.batal()
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), (this.kode_toko.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  }, [_vm._v("Tampilkan")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalLunas),
      expression: "loadingModalLunas"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormLunas,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormLunas = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan melakukan pelunasan tanggal " + _vm._s(_vm.tanggal) + "-" + _vm._s(_vm.bulan) + "-" + _vm._s(_vm.tahun) + " sebesar Rp " + _vm._s(_vm.toMoney(_vm.nominal)) + " ?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormLunas = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmLunas1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Saving",
      "visible": _vm.dialogFormVisible,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tanggal",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.row1.tanggal),
      callback: function($$v) {
        _vm.$set(_vm.row1, "tanggal", $$v)
      },
      expression: "row1.tanggal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keterangan",
      "prop": "nama"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Pilih Keterangan"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  }, _vm._l((_vm.namas), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.nama
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jumlah",
      "prop": "jumlah"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.row1.jumlah),
      callback: function($$v) {
        _vm.$set(_vm.row1, "jumlah", $$v)
      },
      expression: "row1.jumlah"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Wilayah",
      "visible": _vm.dialogFormEdit,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jumlah",
      "prop": "jumlah"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.row1.jumlah),
      callback: function($$v) {
        _vm.$set(_vm.row1, "jumlah", $$v)
      },
      expression: "row1.jumlah"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.row1.tanggal),
      callback: function($$v) {
        _vm.$set(_vm.row1, "tanggal", $$v)
      },
      expression: "row1.tanggal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.pegawai,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangePegawai
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(scope.$index + 1) + "\n                      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "SKU",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(scope.row.sku) + "\n                      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(scope.row.nama) + "\n                      ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDet),
      expression: "loadingModalDet"
    }],
    attrs: {
      "title": 'Detail Transaksi #' + _vm.nomor_penjualan,
      "visible": _vm.dialogDet,
      "width": "700px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDet = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData7,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "MENU",
      "prop": "menu",
      "header-align": "left",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "QTY",
      "prop": "qty",
      "header-align": "center",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.qty)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "HARGA",
      "prop": "harga_satuan",
      "header-align": "center",
      "align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.harga_satuan)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "TOTAL",
      "prop": "total",
      "header-align": "center",
      "align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.total)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogDet = false
      }
    }
  }, [_vm._v("TUTUP")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus " + _vm._s(_vm.nama) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Info",
      "visible": _vm.dialogFormInfo,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e6af5ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/Penjualan1.vue
// module id = 1382
// module chunks = 2